export default "__VITE_ASSET__wmQdf$rA__"